import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef, ViewEncapsulation } from '@angular/core';
import { AbstractControl, AsyncValidatorFn, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectComponent } from '@ng-select/ng-select';
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable';
import { ApiService } from 'app/shared/services/api.service';
import { environment } from 'environments/environment';
import moment from 'moment';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import swal from 'sweetalert2';
import { DynamicDetailComponent } from '../../../dynamic-detail/dynamic-detail.component';
@Component({
  selector: 'app-attendence-report',
  templateUrl: './attendence-report.component.html',
  styleUrls: ['./attendence-report.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class AttendenceReportComponent implements OnInit {


  @ViewChild(DatatableComponent) table: DatatableComponent;
  page = {
    pageNumber:0,
    offset: 0,
    pageSize: 100,
    totalPages:0
  };
  // row data
  public rows:any = [];
  public filterRows=[];
  public ColumnMode = ColumnMode;
  public limitRef = 100;
  selectedValue=''
  isFilter:boolean=false
  public columns = [
    { name: "Name", prop: "displayname" },
    {name:"Tag Type",prop:"tagcategories_ids"},
    { name: "Notes", prop: "notes" },
    { name: "Admin Notes", prop: "admin_notes" },
    { name: "Actions", prop: "Actions" },
  ];
  public empAttendView: boolean[] = [];
  

  // private
  private tempData = []; 

  imageUrl=environment.apiUrls.imageUrl;
  

  attendence_id:any
  searchVal:any;
  @ViewChild('name') inputName
  user_role:any
  isVerified: boolean =false

  month_list=[
    {name:'January',_id:'01'},
    {name:'February',_id:'02'},
    {name:'March',_id:'03'},
    {name:'April',_id:'04'},
    {name:'May',_id:'05'},
    {name:'June',_id:'06'},
    {name:'July',_id:'07'},
    {name:'August',_id:'08'},
    {name:'September',_id:'09'},
    {name:'October',_id:'10'},
    {name:'November',_id:'11'},
    {name:'December',_id:'12'},

  ]
  selected_month
  selected_month_id
  years_list=[]
  selected_year
  start_date
  end_date
  verified_list =[
    {name:'No',_id:'no'},
    {name:'Yes',_id:'yes'},
    {name:'In-review',_id:'inreview'},
    {name:'All',_id:'all'},
  ]

  attendenceForm:FormGroup;

  selected_emp=null;
  selected_allEmp :string []=[]
  emp_list=[]
  empFullPart_list=[]

  attendenceFormSubmitted:boolean=false;
  model={
      user: '',
      startTime: '10:00',
      endTime: '19:00',
      workingHours:'',
      attendanceDate: new Date(),
      notes: '',
      isVerified: '',
      task: '',
      status: '',
      admin_notes: '',
  }
  selected_verified='yes'
  selected_verified_filter='all'
  startTime= new FormControl()
  endTime= new FormControl()
  s_time:any
  e_time:any
  timeDiff:any
  current_date = new Date().toDateString();
  employee_badge_cat_id = '64b124832d735e2b98be9fd7'
  status_list=[]
  selected_status = null
  minDate:any
  maxDate:any
  days_list=[
    {name:'1 Day' , _id:'one'},
    {name:'2 Days' , _id:'two'},
    {name:'3 Days' , _id:'three'},
    {name:'4 Days' , _id:'four'},
    {name:'5 Days' , _id:'five'},
    {name:'6 Days' , _id:'six'},
    {name:'7 Days' , _id:'seven'},
  ]
  selected_day = null
  emp_data:any
  status_count_data=[]
  @ViewChild('mySelect') mySelect: NgSelectComponent;

  filter_list=[
    {name:'Single Date',_id:'single'},
    {name:'Multiple Date',_id:'multiple'},
  ]
  selected_filter = 'single'
  combinedArray: any[] = [];
  @ViewChild('filterSelect') filterSelect: NgSelectComponent;
  select_attendanceDate = new Date()
  isAttend_search : boolean

  guideline_data:any

  constructor( public apiService:ApiService,private formBuilder:FormBuilder,
               private modalService: NgbModal,
               public toastr: ToastrService,
               private spinner: NgxSpinnerService) { 
               this.user_role=JSON.parse(localStorage.getItem('user'))
               let setting_data = JSON.parse(localStorage.getItem('setting-record'))
               let key_data = setting_data.filter((item) => item.key == 'Attendance Report') 
              this.guideline_data = key_data[0]?._id
                }

  ngOnInit(): void {
    const sevenDaysAgo = new Date();
    sevenDaysAgo.setDate(sevenDaysAgo.getDate() - 6);
    this.minDate = sevenDaysAgo.toISOString().split('T')[0];
    this.maxDate = new Date().toISOString().split('T')[0];

    const startDate = new Date();
    startDate.setDate(startDate.getDate());
    this.start_date = startDate.toISOString().split('T')[0];
    const endDate = new Date();
    this.end_date = endDate.toISOString().split('T')[0];

    this.attendenceForm=this.formBuilder.group({
      attendanceDate: ['', Validators.required],
      notes: ['', ],
      admin_notes: ['', ],
      task: ['', [Validators.required],[this.asyncTaskValidator()]]
    })
    this.startTime.valueChanges.subscribe((value) => {
      this.s_time = new Date(this.current_date+" "+value)
      this.getDiff(this.s_time,this.e_time)
    })
    this.endTime.valueChanges.subscribe((value) => {
      this.e_time = new Date(this.current_date+" "+value)
      this.getDiff(this.s_time,this.e_time)
    })

    if(this.selected_filter == 'single'){
      this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
      
    }
    if(this.selected_filter == 'multiple'){
      this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
    }
   
    this.getAllEmpList()
    this.getStatusList()
  }
  asyncTaskValidator(): AsyncValidatorFn {
    return (control) => {
      const value = control.value;

      return new Promise((resolve) => {
        // Simulate an asynchronous validation
        setTimeout(() => {
          if (value && value.trim().length < 20) {
            resolve({ 'notEnoughCharacters': true });
          } else {
            resolve(null); // Validation passed
          }
        }, 1000); // Simulate a delay of 1 second
      });
    };
  }
  getFilterId(event){
    this.selected_filter
    if(this.selected_filter == 'single'){
      this.filterSelect.close();
      let today_date = new Date()
      this.start_date = today_date.toISOString().split('T')[0];
      this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
    }
    else {
      this.filterSelect.close();

      const startDate = new Date();
      startDate.setDate(startDate.getDate());
      this.start_date = startDate.toISOString().split('T')[0];
      this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
    }
  }

getDiff(stime, etime) {
  if (stime && etime) {
    const startDate = new Date(stime);
    const endDate = new Date(etime);

    // If endTime is before startTime, assume it's on the next day
    if (endDate < startDate) {
      endDate.setDate(endDate.getDate() + 1);
    }

    const diffInMilliseconds = endDate.getTime() - startDate.getTime();
    const hours = Math.floor(diffInMilliseconds / 3600000);
    const minutes = Math.floor((diffInMilliseconds % 3600000) / 60000);

    this.timeDiff = `${hours} hours ${minutes} minutes`;
  }
}
  getStartDate(event){
    this.start_date = event.target.value
   
    if(this.selected_filter == 'single'){
      this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
    }
    else  this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
  }
  getEndDate(event){
    this.end_date = event.target.value
    this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
  }
  getEmpId(event:any){
    this.selected_emp
    this.getEmpById(this.selected_emp)
  }
  getVerifiedId(event:any){
    this.selected_verified
  }
  getFilterVerifiedId(event:any){
    this.selected_verified_filter
    this.mySelect.close();
    this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
  }
  getAllEmpList(){
    this.apiService.getEmployeeList(1,100).subscribe((res:any)=>{
      this.emp_list=res?.items
    })
  }
 getMonthId(id,name){
  this.selected_month = name
  this.selected_month_id = id
  if(!this.selected_year){
    this.selected_year=''
  }
  this.getAttendenceByMonthYear(this.selected_year,this.selected_month_id)
 }
 getYearId(year){
  this.selected_year = year
  if(!this.selected_month_id){
    this.selected_month_id =''
  }
  this.getAttendenceByMonthYear(this.selected_year,this.selected_month_id)
 }
 getYearList() {
  const currentYear = new Date().getFullYear();
  const startYear = currentYear - 2;
  const endYear = currentYear;
  for (let year = startYear; year <= endYear; year++) {
    this.years_list.push(year);
  }
}
  getAllAttendence(startDate,endDate,verified_filter){
    this.spinner.show(undefined,
      {
        type: 'ball-triangle-path',
        size: 'medium',
        bdColor: 'rgba(0, 0, 0, 0.8)',
        color: '#fff',
        fullScreen: true
      });
    this.apiService.getEmpAttendanceList(this.page.pageNumber+1,this.limitRef,startDate,endDate,verified_filter).subscribe((res:any)=>{
      this.spinner.hide();
      if(res && this.selected_filter =='single'){
        this.checkEmpAttendence(this.start_date)
      }
      this.rows = res?.data?.items
      this.combinedArray = [...this.rows]

      this.status_count_data = res?.data?.statusCounts
      this.page.totalPages = res?.data?.totalCount
    })
  }
  getAttendenceByMonthYear(year,month){
    this.apiService.getEmpAttendanceListByMonth(year,month).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.rows=res?.data?.items
        this.page.totalPages=res?.data?.items[0]?.users?.length
      }
    })
  }
  checkEmpAttendence(data){
    let date = moment(data).format('YYYY-MM-DD')
    this.apiService.checkEmpAttendance(date).subscribe((res:any)=>{
      this.empFullPart_list = res?.data?.items
      this.selected_allEmp = res?.data?.items?.map((item) => item.userId)
      let array=[]
      this.empFullPart_list.forEach(item =>{
        array.push({
          user: item.user,
          startTime: '',
          endTime: '',
          workingHours:'',
          attendanceDate: this.start_date ,
          notes: '',
          isVerified: '',
          task: '',
          status: '',
          admin_notes: '',
        })
        this.page.totalPages = item.length
      })
      this.combinedArray = [...this.rows, ...array ]
    })
  }
  pageChangeData(page:any){
    this.apiService.getEmpAttendanceList(page.offset +1,page.pageSize,this.start_date,this.end_date,this.selected_verified_filter).subscribe((res:any)=>{
      this.rows=res.data.items
      this.page.totalPages=res.data.totalCount
    })
  }
  filterAttendence(data:any){
    this.isAttend_search = true
    if(data){
      this.apiService.getFilterAllEmpAttendance(data,this.start_date,this.end_date).subscribe((res:any)=>{
        this.rows = res?.data?.items
        this.combinedArray = [...this.rows]
        this.status_count_data = res?.data?.statusCounts
        this.page.totalPages=res.data.totalCount
      })
    }
  }
  resetFilter(){
    this.inputName.nativeElement.value=''
    this.selected_verified_filter = 'all'
    this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
  }

 
  filterAttendenceWithTwoDates(startDate,endDate){
    this.apiService.getEmpAttendanceListByTwoDateStatusWise(startDate,endDate).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.rows=res?.data?.items
      }
    })
  }
  getStatusList(){
    this.apiService.getTagByTagCatgoryId(this.employee_badge_cat_id).subscribe((res:any)=>{
      this.status_list=res.data
      this.status_list = res.data.filter(item =>
        ["full-day", "short-leave", "half-day","paid-leave","unpaid-leave"].includes(item.name)
    );
    let status_idd = this.status_list.filter((item)=> ['full-day'].includes(item.name))
    this.selected_status = status_idd[0]?._id
    })
  }
  getStatusId(event){
    this.selected_status
  }
  openModalAddNew(content,id,prop){
    console.log(id,'iddd')
    if(prop =='edit'){
      this.attendence_id = id
      this.getAttendenceById(id)
      this.getEmpById(this.attendence_id)

    }
    if(prop =='rowuseradd'){
      this.selected_emp = id
      this.getEmpById(this.selected_emp)
    }
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      // console.log(`Modal closed with result: ${result}`);
      this.selected_emp = null
      this.attendenceForm.reset()
    }, (reason) => {
      // console.log(`Modal dismissed with reason: ${reason}`);
      this.selected_emp = null
      this.attendenceForm.reset()
    });
  }
  getAttendenceById(id){
    this.apiService.getAttendanceById(id).subscribe((res:any)=>{
      this.model.attendanceDate = res?.data?.items[0]?.attendanceDate
      this.model.startTime = res?.data?.items[0]?.startTime
      this.model.endTime = res?.data?.items[0]?.endTime
      this.timeDiff = res?.data?.items[0]?.workingHours
      this.model.workingHours = this.timeDiff
      this.model.task = res?.data?.items[0]?.task
      this.model.notes = res?.data?.items[0]?.notes
      this.model.admin_notes = res?.data?.items[0]?.admin_notes

      this.selected_verified = res?.data?.items[0]?.isVerified
      this.model.isVerified = this.selected_verified
      this.selected_emp = res?.data?.items[0]?.user?._id
      this.model.user = this.selected_emp
      this.selected_status = res?.data?.items[0]?.status?._id
      this.model.status = this.selected_status

    })
  }

  submit(){
    let attendenceDate = moment(this.attendenceForm.value.attendanceDate).format('DD-MM-YYYY')
    let body ={
      user : this.selected_emp?this.selected_emp: this.user_role.id,
      startTime: this.startTime.value,  
      endTime: this.endTime.value,
      workingHours : this.timeDiff,
      attendanceDate: attendenceDate,
      notes: this.attendenceForm.value.notes,
      admin_notes: this.attendenceForm.value.admin_notes,
      isVerified: this.selected_verified,
      task: this.attendenceForm.value.task,
      status : this.selected_status
    }
    if(!this.attendence_id){
      this.apiService.addEmpAttendanceHr(body).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Add Attendance Successfully')
          this.modalService.dismissAll()
          if(this.selected_filter == 'single'){
            this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
            
          }
          if(this.selected_filter == 'multiple'){
            this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
          }
        }
        else{this.toastr.error(res.error)}
      })
        this.attendenceFormSubmitted = true;
      if (this.attendenceForm.invalid) {
        return;
      }
    }
    if(this.attendence_id){
      this.model.isVerified = this.selected_verified
      this.model.status = this.selected_status
      this.model.workingHours = this.timeDiff
      this.apiService.updateEmpAttendance(this.attendence_id,this.model).subscribe((res:any)=>{
        if(res.statusCode === 200){
          this.toastr.success('Add Attendance Successfully')
          this.modalService.dismissAll()
          if(this.selected_filter == 'single'){
            this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
            
          }
          if(this.selected_filter == 'multiple'){
            this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
          }
        }
        else{this.toastr.error(res.error)}
      })
    }

  }
  updateVerifyStatus(row_id,status_id){
    let  body={
      isVerified:  status_id
    }
    this.apiService.updateAttendance(row_id,body).subscribe((res:any)=>{
      if(res.statusCode === 200){
        this.toastr.success('update verify status Successfully')
        this.modalService.dismissAll()
        if(this.selected_filter == 'single'){
          this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
          
        }
        if(this.selected_filter == 'multiple'){
          this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
        }
      }
      else{this.toastr.error(res.error)}
    })
  }
  deleteAttendence(id) {
    this.apiService.deleteAttendance(id).subscribe((res: any) => {
      if(res.statusCode === 200){
        swal.fire({
          icon: "success",
          title: 'Deleted!',
          text: 'Your file has been deleted.',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
        if(this.selected_filter == 'single'){
          this.getAllAttendence(this.start_date,this.start_date,this.selected_verified_filter)
          
        }
        if(this.selected_filter == 'multiple'){
          this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
        }
      }
      else {
        swal.fire({
          icon: "error",
          title: 'Error!',
          text: `${res.error}`,
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    })
  }

   // ================== Delete Alert ========================
   confirmDelete(id: any) {
    this.attendence_id = id
    swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to delete this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#2F8BE6',
      cancelButtonColor: '#F55252',
      confirmButtonText: 'Yes, delete it!',
      customClass: {
        confirmButton: 'btn btn-warning',
        cancelButton: 'btn btn-danger ml-1'
      },
    }).then((result) => {
      if (result.value) {
        this.deleteAttendence( this.attendence_id)

      } else if (result.dismiss === swal.DismissReason.cancel) {
        swal.fire({
          title: 'Cancelled',
          text: 'Your file is safe ',
          icon: 'error',
          customClass: {
            confirmButton: 'btn btn-success'
          },
        })
      }
    });
  }
  openModalNew(content){
    const modalRef = this.modalService.open(content);
    modalRef.result.then((result) => {
      this.selected_allEmp =[]
    }, (reason) => {
      this.selected_allEmp =[]
      // console.log(`Modal dismissed with reason: ${reason}`);
    });
  }
  submitAttend(){
    const date = moment(new Date()).format('DD-MM-YYYY')
    let value = '10:00'
    let value2 = '19:00'
    this.s_time = new Date(this.current_date+" "+value)
    this.e_time = new Date(this.current_date+" "+value2)
    this.getDiff(this.s_time,this.e_time)
    let day ={
      day : this.selected_day
    }
    let body ={
      user : this.selected_allEmp,
      startTime: '10:00',  
      endTime: '19:00',
      workingHours : this.timeDiff,
      attendanceDate: date,
      notes: 'notes',
      admin_notes: 'admin_notes',
      isVerified: this.selected_verified,
      task: 'task',
      status : this.selected_status
    }
 
    this.apiService.addBulkAttendance(body).subscribe((res:any)=>{
      if(res?.statusCode === 200){
        this.toastr.success(res?.message)
        this.modalService.dismissAll()
        this.getAllAttendence(this.start_date,this.end_date,this.selected_verified_filter)
        this.checkEmpAttendence(this.start_date)
      }
      else this.toastr.error(res.error)
    })
  }
  
  getDayId(event){
   this.selected_day
  }
  getEmpById(id){
    this.apiService.getEmployeeById(id).subscribe((res:any)=>{
      this.emp_data = res?.data
    })
  }
  importTask(){
    this.model.task = this.emp_data.current_task
  }
  selectedDateEmpAttendence(event){
    this.select_attendanceDate =  event.target.value
    let date = moment(this.select_attendanceDate).format('YYYY-MM-DD')
    this.apiService.checkEmpAttendance(date).subscribe((res:any)=>{
      this.empFullPart_list = res?.data?.items
      this.selected_allEmp = res?.data?.items?.map((item) => item.userId)
      let array=[]
      this.empFullPart_list.forEach(item =>{
        array.push({
          user: item.user,
          startTime: '',
          endTime: '',
          workingHours:'',
          attendanceDate: this.start_date ,
          notes: '',
          isVerified: '',
          task: '',
          status: '',
          admin_notes: '',
        })
        this.page.totalPages = item.length
      })
      this.combinedArray = [...this.rows, ...array ]
    })
  }
  mediumDate(date) {
    if (!date) return '';
  
    // Convert the input date to a Date object
    const dateObj = new Date(date);
  
    // Define months array for formatting
    const months = [
      'Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun',
      'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'
    ];
  
    // Extract date components
    const month = months[dateObj.getUTCMonth()];
    const dayOfMonth = dateObj.getUTCDate();
    const year = dateObj.getUTCFullYear();
  
    // Format the date in 'Jun 15, 2015' style
    return `${month} ${dayOfMonth}, ${year}`;
  }
  openDynamicModal(key_id:string) {
    const modalOptions: NgbModalOptions = {
      size: 'lg', // 'sm', 'lg', or 'xl'
      backdrop: 'static',
    };
    const modalRef = this.modalService.open(DynamicDetailComponent,modalOptions);
    modalRef.componentInstance.key_id = key_id;
  }
}
